import ManagersTable from './ManagersTable';

export default ManagersTable;
